import React, { useState, useLayoutEffect } from 'react';
import useWindowSize from './useWindowSize';

const useIsOverflow = (
  ref: React.MutableRefObject<any>,
  horizontal?: boolean,
  deps: any[] = [],
) => {
  const [isOverflow, setIsOverflow] = useState<boolean>(false);
  const size = useWindowSize();

  useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow = horizontal
        ? current.scrollWidth > current.clientWidth
        : current.scrollHeight > current.clientHeight;

      setIsOverflow(hasOverflow);
    };

    if (current) {
      trigger();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [horizontal, ref, size, ...deps]);

  return isOverflow;
};

export default useIsOverflow;
